
import Home from "./Global/home";



//App is the blc top component beyoned index js, unless neccessary it should be remain simple and clean, all component head to App component like as a Pyramid structure.
function App() {
  return (
    <>
      <div className="App">
        <Home />
      </div>
    </>
  );
}

export default App;
